package com.jingfangpai.api.base

import com.jingfangpai.common.data.model.NetworkConfig
import com.jingfangpai.common.coroutines.customMainScope
import io.ktor.client.*
import io.ktor.client.plugins.HttpTimeout
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.plugins.defaultRequest
import io.ktor.client.request.header
import io.ktor.http.*
import io.ktor.serialization.kotlinx.json.json

//import io.ktor.serialization.kotlinx.json.*
import kotlinx.coroutines.CoroutineScope

/**
 * 接口基础类
 **/

open class BaseServiceClient(
    private val mainScope: CoroutineScope = customMainScope(),
    networkConfig: NetworkConfig = defaultNetworkConfig,
) : CoroutineScope by mainScope {
    protected val httpClient: HttpClient = getDefaultHttpClient(networkConfig)

    private fun getDefaultHttpClient(networkConfig: NetworkConfig): HttpClient = HttpClient() {
        defaultRequest {
            url {
                host = networkConfig.host
                port = networkConfig.port
                protocol = if (networkConfig.secure) URLProtocol.HTTPS else URLProtocol.HTTP
            }
            getHttpHeaders().forEach {
                header(it.first,it.second)
            }
        }
        install(ContentNegotiation) {
            json(com.jingfangpai.common.json.json)
        }
        install(HttpTimeout) {
            // timeout config
            requestTimeoutMillis = 300000
            socketTimeoutMillis = 300000
        }
    }
}

val defaultNetworkConfig = getNetworkConfig()
